import { Meta } from '@components/atoms/MetaTags/Meta';
import { Oewa } from '@components/atoms/Oewa/Oewa';
import { Title } from '@components/atoms/Title';
import { Channel } from '@components/molecules/Channel/Channel';
import { Default as DefaultLayout } from '@components/templates/layouts/Default';
import { extractSsrState } from '@lib/graphql/helpers/extractSsrState';
import { useTagManager } from '@lib/hooks/useTagManager';
import { IconStar } from '@src/assets/icon-star';
import { GetBySlugDocument } from '@src/lib/graphql/generated';
import { fetchChannels } from '@src/lib/graphql/helpers/fetchChannels';
import { createUrqlClient } from '@src/lib/graphql/urql';
import { getCookie } from '@utils/cookies';
import { AditionInitialization, AditionTagPlacement, Link } from '@vgn-medien-holding/vgn-fe-components';
import Head from 'next/head';

// Sender
const ad_settings_Sender = {
  mobile_middle1: {
    id: 5256647,
    name: 'TVM_Mobile_Sender_MedRec_Cad',
    yieldLab: [],
    breakpoints: [0, 1, 2, 3],
  },
};

export function ChannelIndex({ data, entry }) {
  const { channels } = data;

  useTagManager({
    event: 'metadata',
    loginStatus: 'nicht eingeloggt',
    seitentyp: 'Channels',
    titel: 'Channels',
    aktualisierungsdatum: data?.updated_at,
    erstellungsdatum: data?.created_at,
    oewaSeitenkontingent: 'Service',
    oewaSubkontingent: 'Programmeundlokalfuehrer',
    oewaProfilingkontingent: 'TVProgramme',
    cookieAlert: getCookie('OptanonConsent'),
  });

  return (
    <DefaultLayout>
      <AditionInitialization data={{ ad_settings: ad_settings_Sender }} />
      <Oewa pageKey={'Service'} categoryKey={'Programmeundlokalfuehrer'} profileKey={'TVProgramme'} />
      <Head>{entry != null && Meta(entry?.metadata, entry?.metadata?.meta_title)}</Head>
      <div className="mb-6 flex items-center justify-between gap-3">
        <Title classProps={{ heading: 'text-xl lg:text-xl' }} level={1}>
          {entry?.title ?? 'Sender'}
        </Title>
        <div>
          {process.env.NEXT_PUBLIC_SHOW_LOGIN === 'true' && (
            <Link
              href="/favoriten/sender"
              classProps={{
                root: 'label-base inline-flex h-12 w-full place-items-center justify-center gap-2 rounded-full border border-gray-650/25 bg-gray-820/70 p-4 transition-colors duration-200 hover:border-primary hover:text-primary',
              }}
            >
              <IconStar classProps={{ root: 'w-4 h-4' }} filled />
              Favoriten
            </Link>
          )}
        </div>
      </div>
      <div className="grid grid-flow-dense grid-cols-fill-streaming-squares gap-4">
        {/* after every 8th add ad placemenent that fills whole space */}
        {channels.map((channel, index) => (
          <>
            {index % 8 === 0 && index !== 0 && (
              <AditionTagPlacement
                tag={ad_settings_Sender.mobile_middle1}
                classProps={{ root: 'col-span-full mx-auto md:hidden' }}
              />
            )}
            <div key={channel.id}>
              <Channel key={channel.id} channel={channel} />
            </div>
          </>
        ))}
      </div>
    </DefaultLayout>
  );
}
export const senderIndexSsrLogic = async () => {
  const { ssrQuery, ssrCache } = createUrqlClient();
  const channels = await fetchChannels();
  const { data: pageData } = await ssrQuery({
    query: GetBySlugDocument,
    variables: {
      portal: 'tvmedia',
      slug: '/sender',
    },
  });
  const page = pageData?.findBySlug;

  return {
    props: {
      data: { channels: channels.data || [] },
      entry: page,
      slug: 'index',
      urqlState: extractSsrState(ssrCache),
    },
  };
};
